import React, { useState } from "react";
import { Modal } from "@truevault/aquilo";
import {
  VendorInventoryFooterState,
  VendorInventoryPageConfig,
  VendorInventoryPageContent,
} from "../../../data-map/vendor-inventory/VendorInventoryPage";
import { Routes } from "../../../../root/routes";
import { EmployeePageWrapper } from "./EmployeePageWrapper";
import { useHistory } from "react-router";

const HR_VENDOR_INVENTORY_CONFIG: VendorInventoryPageConfig = {
  collectionContext: "EMPLOYEE",
  categoryGroupMode: "hr",
  breadcrumbTitle: "HR Vendor List",
  breadcrumbSource: "HR Center",
  breadcrumbSourceRoute: Routes.hrCenter.root,
  includeEmptyContext: false,
  showConsumerOnboarding: false,
  showIncompleteVendorWarning: true,
  // Let HR reuse Consumer-only custom vendors/storage instead of creating duplicates.
  showConsumerOnlyCustomVendorsAndStorageLocations: true,
  addVendorInfoTitle:
    "Add HR vendors, employment-related service providers, or internal HR data storage locations.",
  addVendorInfoBody:
    "Use this inventory for vendors and sources that handle employee, contractor, or job applicant data.",
  recipientsHelpExamples: "payroll, benefits, and HR software providers",
  sourcesRoute: Routes.hrCenter.hrDataMap.employeeSources,
  sourcesLinkLabel: "HR Data Map → Employee Sources",
};

export function HRVendorInventoryPage() {
  const history = useHistory();
  const [footerState, setFooterState] = useState<VendorInventoryFooterState>({
    showFooter: false,
    nextDisabled: true,
    isSidebarOpen: false,
    hasOnlyTruevaultVendor: false,
  });
  const [isInventoryConfirmationOpen, setIsInventoryConfirmationOpen] = useState(false);

  const continueToDataFlows = () => history.push(Routes.hrCenter.hrDataMap.dataFlows);

  return (
    <>
      <EmployeePageWrapper
        selectedTabKey="hr-vendor-inventory"
        // Footer visibility is driven by finished-hr-data-map inside EmployeePageWrapper
        nextOnClick={() => {
          if (footerState.hasOnlyTruevaultVendor) {
            setIsInventoryConfirmationOpen(true);
            return;
          }

          continueToDataFlows();
        }}
        nextDisabled={footerState.nextDisabled}
        hideFooter={footerState.isSidebarOpen}
        nextDisabledTooltip={
          footerState.nextDisabled ? "Complete your vendor list before proceeding." : undefined
        }
      >
        <VendorInventoryPageContent
          config={HR_VENDOR_INVENTORY_CONFIG}
          onFooterStateChange={setFooterState}
        />
      </EmployeePageWrapper>

      {isInventoryConfirmationOpen && (
        <Modal
          title="Have you included all HR Vendors, Internal Data Storage locations, Contractors, and other external HR parties?"
          body="Your Vendor List should include all parties and locations where your business collects or shares consumer personal data. Make sure your list is complete before moving on to the next steps."
          alignText="left"
          alignButton="right"
          firstButton="I’ll Take Another Look"
          onFirstButtonClick={() => setIsInventoryConfirmationOpen(false)}
          secondButton="Everything Is Included"
          secondButtonColor="primary"
          onSecondButtonClick={continueToDataFlows}
          showOverlay
          closeButton
          onClose={() => setIsInventoryConfirmationOpen(false)}
          maxPanelWidth="max-w-[700px]"
        />
      )}
    </>
  );
}
